import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OptionPanel from '../../OptionPanel';
import { GeckoIcon, OverlayTrigger, Tooltip } from 'ui';

import { GeckoFields, GECKO_CONSTS } from 'ui';
import ReplyBoxField from 'components/ReplyBoxField';
import ReplyBoxWithSenderField from 'components/ReplyBoxWithSenderField';
import BotSelect from 'components/BotSelect';
import TagSelect from 'components/TagSelect';
import FieldSelect from 'components/FieldSelect';
import CustomFieldInput from 'components/CustomFieldInput';
import GeckoFeatures from 'services/gecko-features';
import {
  buildContactGroup,
  buildSelectedChannelGroup,
} from 'services/template-tags';

import Field from './Field';
import { CONSTS } from 'constants/index.js';

const RichTextAndTagTooltip = () => {
  return (
    <span className="Steps-ActionWorkflow-message-tooltip">
      <OverlayTrigger
        placement="auto"
        delay={{ show: 0, hide: 0 }}
        overlay={
          <Tooltip id={'rich-text-tip'}>
            Rich text formatting will be removed from this message if it
            contains mailmerge tags
          </Tooltip>
        }
      >
        <i id={'rich-text-tip'}>
          <GeckoIcon icon="far fa-info-circle" />
        </i>
      </OverlayTrigger>
    </span>
  );
};

class AddActions extends Component {
  static propTypes = {
    value: PropTypes.shape({
      type: PropTypes.string,
      value: PropTypes.any,
    }),
    onChange: PropTypes.func,
    trigger: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedField: null,
    };
  }

  isSelected(value) {
    return this.props.value && this.props.value.type === value;
  }

  onSelect(type, value) {
    return () => {
      const newValue = Object.assign({}, this.props.value, { type, value });
      this.props.onChange(newValue);
    };
  }

  onChange(_key, val) {
    const newValue = Object.assign({}, this.props.value, { value: val });
    this.props.onChange(newValue);
  }

  templateContext() {
    return [
      buildContactGroup(),
      buildSelectedChannelGroup({
        channel: null,
        showChannelQueuePosition: true,
      }),
    ];
  }

  checkForChannelConditions() {
    if (!this.props.conditions) return null;
    let channelConditionExists = false;
    this.props.conditions.filter((rule) =>
      rule.conditions.filter((config) => {
        if (config.key === 'live_chat_channel') channelConditionExists = true;
      })
    );
    return channelConditionExists;
  }

  getField() {
    if (!this.props.value || !this.props.value.type) {
      return null;
    }
    if (this.props.value.type === 'assign_conversation') {
      const fieldConf = [
        {
          key: 'value',
          placeholder: 'Pick users or teams in the dropdown',
          type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
          options: [
            {
              label: 'Teams',
              options: this.props.teams.map((t) => {
                return { label: t.name, value: `team_${t.id}` };
              }),
            },
            {
              label: 'Agents',
              options: this.props.agents.map((a) => {
                return { label: a.full_name, value: `agent_${a.id}` };
              }),
            },
          ],
          width: '100',
          class: 'use-and',
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );
      return (
        <Field
          icon="far fa-users"
          text="Assign conversation to"
          field={field}
          color="rgb(77, 146, 223)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'pre_assign_conversation') {
      const fieldConf = [
        {
          key: 'value',
          placeholder: 'Pick users or teams in the dropdown',
          type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
          options: [
            {
              label: 'Teams',
              options: this.props.teams.map((t) => {
                return { label: t.name, value: `team_${t.uuid}` };
              }),
            },
            {
              label: 'Agents',
              options: this.props.agents.map((a) => {
                return { label: a.full_name, value: `agent_${a.uuid}` };
              }),
            },
          ],
          width: '100',
          class: 'use-and',
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );
      return (
        <Field
          icon="far fa-users"
          text="Assign conversation to"
          field={field}
          color="rgb(77, 146, 223)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'pre_assign_bot') {
      const fieldConf = [
        {
          key: 'value',
          placeholder: 'pick a bot in the dropdown',
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          component: <BotSelect />,
          width: '100',
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );
      return (
        <Field
          icon="far fa-robot"
          text="Assign conversation to"
          field={field}
          color="rgb(77, 146, 223)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'contact_note') {
      const fieldConf = [
        {
          key: 'value',
          placeholder: 'Enter text here',
          type: GECKO_CONSTS.FIELD_TYPE_TEXT,
          width: '100',
          class: 'AddConditions-Condition-select-value',
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );
      return (
        <Field
          icon="far fa-sticky-note"
          text="Add a note that reads"
          field={field}
          color="rgb(232, 211, 105)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'contact_tag') {
      const fieldConf = [
        {
          key: 'value',
          placeholder: 'pick tags in the dropdown',
          type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
          options: this.props.tags.map((tag) => {
            return { label: tag.name, value: tag.id };
          }),
          width: '100',
          class: 'use-and',
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );
      return (
        <Field
          icon="far fa-tags"
          text="Add the following tags to the Contact"
          field={field}
          color="rgb(66, 244, 92)"
          removeAction={this.props.removeAction}
        />
      );
    }

    if (this.props.value.type === 'conversation_tag') {
      if (this.props.value.value === undefined) {
        this.onChange(this.props.value, []);
      }
      const fieldConf = [
        {
          key: 'value',
          placeholder: 'pick tags in the dropdown',
          component: (
            <TagSelect
              value={this.props.value.value}
              multi
              create
              onChange={this.onChange.bind(this)}
              config={{
                autoFocus: true,
                openOnFocus: true,
              }}
            />
          ),
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          options: this.props.tags.map((tag) => {
            return { label: tag.name, value: tag.id };
          }),
          width: '100',
          class: 'use-and',
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );
      return (
        <Field
          icon="far fa-tags"
          text="Add the following tags to the Conversation"
          field={field}
          color="rgb(255, 68, 118)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'send_message') {
      const fieldConf = [
        {
          key: 'value',
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          width: '100',
          component: (
            <ReplyBoxField
              compileTemplateTags={false}
              templateContext={this.templateContext()}
              editorMode={CONSTS.EDITOR_MODE_TYPE.RICH}
              formatAsEditorObject
              toolbarClassName={'conversations-toolbar'}
              meta={{
                saved_replies: { show: true },
                mail_merge: { show: true },
              }}
            />
          ),
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );

      const title = (
        <>
          <span>Reply with a message that reads</span>
          <RichTextAndTagTooltip />
        </>
      );

      return (
        <Field
          icon="far fa-comments"
          text={title}
          field={field}
          color="rgb(124, 24, 180)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'prechat_message') {
      const fieldConf = [
        {
          key: 'value',
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          width: '100',
          component: (
            <ReplyBoxWithSenderField
              compileTemplateTags={false}
              useUUID={true}
              templateContext={this.templateContext()}
              editorMode={CONSTS.EDITOR_MODE_TYPE.RICH}
              formatAsEditorObject
              toolbarClassName={'conversations-toolbar'}
              meta={{
                saved_replies: { show: true },
                mail_merge: { show: true },
              }}
            />
          ),
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );

      const title = (
        <>
          <span>Send a message that reads</span>
          <RichTextAndTagTooltip />
        </>
      );
      return (
        <Field
          icon="far fa-comments"
          text={title}
          field={field}
          color="rgb(124, 24, 180)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'prechat_prompt') {
      const fieldConf = [
        {
          key: 'value',
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          width: '100',
          component: (
            <ReplyBoxField
              compileTemplateTags={false}
              templateContext={this.templateContext()}
              editorMode={CONSTS.EDITOR_MODE_TYPE.RICH}
              formatAsEditorObject
              toolbarClassName={'conversations-toolbar'}
              meta={{
                saved_replies: { show: true },
                mail_merge: { show: true },
              }}
            />
          ),
        },
      ];

      const field = (
        <GeckoFields
          fields={fieldConf}
          handler={this.onChange.bind(this)}
          values={this.props.value}
        />
      );

      const title = (
        <>
          <span>Prompt with a message that reads</span>
          <RichTextAndTagTooltip />
        </>
      );

      return (
        <Field
          icon="far fa-comment-plus"
          text={title}
          field={field}
          color="rgb(124, 24, 180)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'launch_widget') {
      const field = (
        <GeckoFields
          fields={[
            {
              key: 'value',
              type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
              render: () => {
                return (
                  <div>
                    <p>
                      On any page that passes your conditions set in step 3.
                    </p>
                  </div>
                );
              },
            },
          ]}
        />
      );
      return (
        <Field
          icon="far fa-comment-lines"
          text="Launch the live chat Widget"
          field={field}
          color="rgb(232, 211, 105)"
          removeAction={this.props.removeAction}
        />
      );
    }
    if (this.props.value.type === 'contact_field') {
      const getNewFieldValue = (selectedField) => {
        const newValue = {
          ...this.props.value.value,
          field_id: selectedField.id,
          field_key: selectedField.key,
        };
        if (selectedField.type === 'display') {
          // Display fields should set to true
          return { ...newValue, value: true };
        }
        return newValue;
      };
      const onFieldSelected = (selectedField) => {
        if (!selectedField) {
          return;
        }
        const newFieldValue = getNewFieldValue(selectedField);
        this.onChange('value', newFieldValue);
        this.setState({ selectedField });
      };
      const fieldConf = [
        {
          key: 'value.field_id',
          placeholder: 'Pick a field to change',
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          component: <FieldSelect onFieldSelected={onFieldSelected} />,
          class: 'Actions-Field-Option',
        },
        {
          key: 'value.placeholder',
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          component: <span className="AddActions-custom-field-span">to</span>,
          hideWhen: () =>
            !this.props.value.value ||
            !this.props.value.value.field_id ||
            !this.state.selectedField,
          class: 'Actions-Field-Operator',
        },
        {
          key: 'value.value',
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          component: <CustomFieldInput field={this.state.selectedField} />,
          hideWhen: () =>
            !this.props.value.value ||
            !this.props.value.value.field_id ||
            !this.state.selectedField,
          class: 'Actions-Field-Value',
        },
      ];
      const onChange = (key, value) => {
        // If the field_id has been blanked clean up the value
        if (key === 'value.field_id' && !value) {
          const newValue = Object.assign({}, this.props.value.value, {
            field_id: null,
            field_key: null,
            value: '',
          });
          return this.onChange('value', newValue);
        }
        // If the key wasn't field_id update the value
        if (key !== 'value.field_id') {
          const newValue = Object.assign({}, this.props.value.value, {
            value: value,
          });
          return this.onChange('value', newValue);
        }
        // Otherwise let the onFieldSelected callback update the field_id
      };
      const values = this.props.value.value ? this.props.value : { value: {} };
      const field = (
        <GeckoFields fields={fieldConf} handler={onChange} values={values} />
      );
      return (
        <Field
          icon="fal fa-user"
          text="Set contact field"
          field={field}
          color="rgb(232, 211, 105)"
          removeAction={this.props.removeAction}
        />
      );
    }
    return null;
  }

  render() {
    const typeMap = {
      'message:new-conversation': [
        <OptionPanel
          id={'assign_conversation'}
          key={'assign_conversation'}
          onSelect={this.onSelect('assign_conversation')}
          index={0}
          selected={this.isSelected('assign_conversation')}
          icon="fal fa-users"
        >
          Assign conversation to agent or team
        </OptionPanel>,
        <OptionPanel
          id={'send_message'}
          key={'send_message'}
          onSelect={this.onSelect('send_message')}
          index={1}
          selected={this.isSelected('send_message')}
          icon="fal fa-comments"
        >
          Trigger a message to the contact
        </OptionPanel>,
        <OptionPanel
          id={'contact_note'}
          key={'contact_note'}
          onSelect={this.onSelect('contact_note')}
          index={2}
          selected={this.isSelected('contact_note')}
          icon={'fal fa-sticky-note'}
        >
          Add a note to the contact
        </OptionPanel>,
        <OptionPanel
          id={'conversation_tag'}
          key={'conversation_tag'}
          onSelect={this.onSelect('conversation_tag')}
          index={3}
          selected={this.isSelected('conversation_tag')}
          icon={'fal fa-tags'}
        >
          Add a tag to the conversation
        </OptionPanel>,
        <OptionPanel
          id={'contact_field'}
          key={'contact_field'}
          onSelect={this.onSelect('contact_field')}
          index={4}
          selected={this.isSelected('contact_field')}
          icon={'fal fa-user'}
        >
          Set a contact field
        </OptionPanel>,
      ],
      'conversation:closed': [
        <OptionPanel
          id={'send_message'}
          key={'send_message'}
          onSelect={this.onSelect('send_message')}
          index={1}
          selected={this.isSelected('send_message')}
          icon="fal fa-comments"
        >
          Trigger a message to the contact
        </OptionPanel>,
        <OptionPanel
          id={'contact_note'}
          key={'contact_note'}
          onSelect={this.onSelect('contact_note')}
          index={2}
          selected={this.isSelected('contact_note')}
          icon={'fal fa-sticky-note'}
        >
          Add a note to the contact
        </OptionPanel>,
        <OptionPanel
          id={'conversation_tag'}
          key={'conversation_tag'}
          onSelect={this.onSelect('conversation_tag')}
          index={4}
          selected={this.isSelected('conversation_tag')}
          icon={'fal fa-tags'}
        >
          Add a tag to the conversation
        </OptionPanel>,
        <OptionPanel
          id={'contact_field'}
          key={'contact_field'}
          onSelect={this.onSelect('contact_field')}
          index={5}
          selected={this.isSelected('contact_field')}
          icon={'fal fa-user'}
        >
          Set a contact field
        </OptionPanel>,
      ],
      'widget:loaded': [
        <OptionPanel
          id={'prechat_prompt'}
          key={'prechat_prompt'}
          onSelect={this.onSelect('prechat_prompt')}
          index={0}
          selected={this.isSelected('prechat_prompt')}
          icon="fal fa-comment-plus"
        >
          Prompt the visitor to open the widget
        </OptionPanel>,
        <OptionPanel
          id={'prechat_message'}
          key={'prechat_message'}
          onSelect={this.onSelect('prechat_message')}
          index={1}
          selected={this.isSelected('prechat_message')}
          icon="fal fa-comments"
        >
          Trigger a message to the visitor
        </OptionPanel>,
        <OptionPanel
          id={'launch_widget'}
          key={'launch_widget'}
          onSelect={this.onSelect('launch_widget', true)}
          index={2}
          selected={this.isSelected('launch_widget')}
          icon={'fal fa-comment-lines'}
        >
          Launch the live chat widget window
        </OptionPanel>,
        <OptionPanel
          id={'pre_assign_conversation'}
          key={'pre_assign_conversation'}
          onSelect={this.onSelect('pre_assign_conversation')}
          index={3}
          selected={this.isSelected('pre_assign_conversation')}
          icon="fal fa-users"
        >
          Assign conversation to agent or team
        </OptionPanel>,
        !GeckoFeatures.can('chat-bot') ? null : (
          <OptionPanel
            id={'pre_assign_bot'}
            key={'pre_assign_bot'}
            onSelect={this.onSelect('pre_assign_bot')}
            index={4}
            selected={this.isSelected('pre_assign_bot')}
            icon="fal fa-robot"
          >
            Assign conversation to a bot
          </OptionPanel>
        ),
        <OptionPanel
          id={'contact_field'}
          key={'contact_field'}
          onSelect={this.onSelect('contact_field')}
          index={5}
          selected={this.isSelected('contact_field')}
          icon={'fal fa-user'}
        >
          Set a contact field
        </OptionPanel>,
      ],
    };
    return (
      <div className="Steps-ActionWorkflow-Action">
        <div className="Steps-ActionWorkflow-Action-options">
          <label>Choose Action Type</label>
          {typeMap[this.props.trigger]}
        </div>
        {this.getField()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    agents: state.visible_agents,
    teams: state.teams,
    tags: state.tags,
    loggedInUser: state.appState.loggedInUser,
  };
};

export default connect(mapStateToProps)(AddActions);
